import { render } from "./Home.vue?vue&type=template&id=b18fa4c8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b18fa4c8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3b689470-9235-485d-ba5a-49630a920e29/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18fa4c8"]])

export default __exports__